// @flow
import CentenairePage from 'components/centenaire/CentenairePage';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/centenaire/CentenairePage';
import { fetchPageList } from 'actions/pageActions';
import { fetchCentenaireDocument } from 'actions/centenaireActions';

export default connect(
  (state: StateType): StateProps => ({
    title: state.pageListState.title,
    description: state.pageListState.description,
    featured_media: state.pageListState.featured_media,
    meta_title: state.pageListState.meta_title,
    meta_description: state.pageListState.meta_description,
    document: state.centenaireState.document,
    status: state.pageListState.status,
    statusDocument: state.centenaireState.statusDocument,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchPageList: (slug: string) => dispatch(fetchPageList('histoires-de-rugby')),
    fetchCentenaireDocument: (document: string) => dispatch(fetchCentenaireDocument(document)),
  })
)(CentenairePage);
